import React, {useState, useEffect} from 'react';
import styles from '../styles/app.scss';
import {Header} from "./Header";
import {Routes, Route} from "react-router-dom";
import {Home} from "./Home";
import {PageNotFound} from "./PageNotFound";
import {Bio} from "./Bio";
import {Portfolio} from "./Portfolio";
import {Skills} from "./Skills";
import {Blog} from "./Blog";
import {PortfolioRouter} from "./portfolio/PortfolioRouter";
import {AuthDemo} from "./AuthDemo";


export const App = props => {
    return (
        <div className={styles.containerAll}>
            <div className={styles.headerSection}>
                <Header/>
            </div>

            <div className={styles.mainSection}>
                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/cv" element={<Bio/>}/>
                    <Route path="/portfolio" element={<Portfolio/>}/>
                    <Route path="/skills" element={<Skills/>}/>
                    <Route path="/blog" element={<Blog/>}/>
                    <Route path="/portfolio/:project" element={<PortfolioRouter/>}/>
                    <Route path="/demos/auth" element={<AuthDemo/>}/>
                    <Route path="*" element={<PageNotFound/>}/>
                </Routes>
            </div>

            <div className={styles.footerSection}>© 2022 Christopher Bekos. All rights reserved.</div>
        </div>
    )
};
